var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryHt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_7649)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_7649",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_7649)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.33333H28V0H0V9.33333Z",
    fill: "#112EBC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H28V9.33337H0V20Z",
    fill: "#E3264A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 8.66663C9.33325 7.56206 10.2287 6.66663 11.3333 6.66663H16.6666C17.7712 6.66663 18.6666 7.56206 18.6666 8.66663V12.6666C18.6666 13.7712 17.7712 14.6666 16.6666 14.6666H11.3333C10.2287 14.6666 9.33325 13.7712 9.33325 12.6666V8.66663Z",
    fill: "url(#paint0_linear_2858_7649)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2858_7649",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 6,
    width: 10,
    height: 9
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 8.66663C9.33325 7.56206 10.2287 6.66663 11.3333 6.66663H16.6666C17.7712 6.66663 18.6666 7.56206 18.6666 8.66663V12.6666C18.6666 13.7712 17.7712 14.6666 16.6666 14.6666H11.3333C10.2287 14.6666 9.33325 13.7712 9.33325 12.6666V8.66663Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2858_7649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66659 14.3333V13.5393L11.5859 12.5797C11.9099 12.4177 12.2672 12.3333 12.6294 12.3333H15.3704C15.7326 12.3333 16.0899 12.4177 16.4139 12.5797L18.3333 13.5393V14.3333H9.66659Z",
    fill: "#AABCAE",
    stroke: "#366C14",
    strokeWidth: 0.666667
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 12C15.1046 12 16 11.1046 16 10C16 8.89543 15.1046 8 14 8C12.8954 8 12 8.89543 12 10C12 11.1046 12.8954 12 14 12Z",
    fill: "#D4B872"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 11.3871C10.9998 11.1076 11.3231 10.9522 11.5414 11.1268L13.3751 12.5938C13.7404 12.886 14.2593 12.886 14.6245 12.5938L16.4583 11.1268C16.6765 10.9522 16.9998 11.1076 16.9998 11.3871V12.6667C16.9998 12.8508 16.8506 13 16.6665 13H11.3332C11.1491 13 10.9998 12.8508 10.9998 12.6667V11.3871Z",
    fill: "#C28321",
    stroke: "#0D3488",
    strokeWidth: 0.666667
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.569 8.56903C12.359 8.35905 12.5078 8 12.8047 8H15.1953C15.4922 8 15.641 8.35905 15.431 8.56904L14.2357 9.7643C14.1055 9.89447 13.8945 9.89447 13.7643 9.7643L12.569 8.56903Z",
    fill: "#216C30"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2858_7649",
    x1: 9.33325,
    y1: 6.66663,
    x2: 9.33325,
    y2: 14.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_7649"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryHt);
export default __webpack_public_path__ + "static/media/Country=HT.b753c0292f316670ea447d5141011cb6.svg";
export { ForwardRef as ReactComponent };